import graphql from "babel-plugin-relay/macro";

const AllCollectionsQuery = graphql`
query AllCollectionsQuery($name:String){
  allCollections(name:$name){
    edges{
      node{       
        id
        name
        icon 
        politicians{
          edges{
            node{
              id
              name
            }
          }
        }
      }
    }
  }
}
`

export default AllCollectionsQuery;